import { forwardRef } from 'react'
import { Input } from '@headlessui/react'
import Search from '../assets/search.svg?react'

interface ISearchBoxProps {
    className?: string
    value?: string
    onChange?: (value: string) => void
    placeholder?: string
}

export const SearchBox = forwardRef<HTMLInputElement, ISearchBoxProps>((props, ref) => {
  return (
    <div className={`${props.className} relative`}>
      <Input
        ref={ref}
        type={'text'}
        placeholder={props.placeholder ?? 'Search'}
        value={props.value}
        onChange={(e) => props.onChange?.(e.target.value)}
        className={
          'border px-8 h-[60px] w-full rounded-[30px] bg-searchBackground border-searchBorder text-2xl font-sf-pro-light data-focus:outline-1 data-focus:outline-searchBorder'
        }
      />
      <div className={'absolute top-0 bottom-0 right-0'}>
        <div className={'flex items-center justify-center h-full mr-8'}>
            <Search width={24} height={24}/>
        </div>
      </div>
    </div>
  )
})
